var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "jflow-restitution-box" },
    [
      _c(
        "Row",
        { staticStyle: { "margin-top": "10px" } },
        [
          _c("Col", { attrs: { span: "24" } }, [
            _c(
              "div",
              [
                _c("span", {}, [_vm._v("回转批注：")]),
                _vm._v(" "),
                _c("Input", {
                  staticClass: "ref_input",
                  attrs: {
                    type: "textarea",
                    autosize: { minRows: 2, maxRows: 5 },
                    placeholder: "请输入转发批注",
                  },
                  model: {
                    value: _vm.inputValue,
                    callback: function ($$v) {
                      _vm.inputValue = $$v
                    },
                    expression: "inputValue",
                  },
                }),
              ],
              1
            ),
          ]),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "pop-btn" },
        [
          _c(
            "Button",
            { staticClass: "cancel-btn", on: { click: _vm.cancel } },
            [_c("span", [_vm._v(_vm._s(_vm.chineseName.CANCEL))])]
          ),
          _vm._v(" "),
          _c(
            "Button",
            {
              staticClass: "sav-btn",
              attrs: { type: "error" },
              on: { click: _vm.save },
            },
            [_c("span", [_vm._v(_vm._s(_vm.chineseName.CONFIRM))])]
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }